import { render, staticRenderFns } from "./image-carousel-list.vue?vue&type=template&id=2e0162cf&scoped=true&"
import script from "./image-carousel-list.vue?vue&type=script&lang=js&"
export * from "./image-carousel-list.vue?vue&type=script&lang=js&"
import style0 from "./image-carousel-list.vue?vue&type=style&index=0&id=2e0162cf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0162cf",
  null
  
)

export default component.exports